/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `pap_application` - PAP Application * `organization_registration` - Organization Registration * `invitation` - Invitation
 */
export type RegistrationSourceEnum = 'pap_application' | 'organization_registration' | 'invitation';

export const RegistrationSourceEnum = {
    PapApplication: 'pap_application' as RegistrationSourceEnum,
    OrganizationRegistration: 'organization_registration' as RegistrationSourceEnum,
    Invitation: 'invitation' as RegistrationSourceEnum
};